import { useState } from 'react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'

import { useLogin, useMe } from '../../hooks/queries'
import { useTexte } from '../../texte'

export function LoginPage() {
  const texte = useTexte()
  const t = texte.anmeldung
  const me = useMe()
  const login = useLogin()
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  // Wer einem Einladungslink gefolgt ist, soll nach dem Anmelden dort landen
  // und nicht auf der Startseite.
  const from = (location.state as { from?: string } | null)?.from ?? '/'

  if (me.data) return <Navigate to={from} replace />

  return (
    <div className="centered">
      <form
        className="card"
        onSubmit={(event) => {
          event.preventDefault()
          login.mutate({ email, password }, { onSuccess: () => navigate(from) })
        }}
      >
        <h1>{t.anmelden}</h1>
        <p className="card__lead">{texte.allgemein.name}</p>

        {login.isError && <p className="notice" role="alert">{login.error.message}</p>}

        <label className="field">
          <span className="field__label">{t.email}</span>
          <input
            className="field__input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <label className="field">
          <span className="field__label">{t.passwort}</span>
          <input
            className="field__input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        <button className="button" type="submit" disabled={login.isPending}>
          {login.isPending ? texte.allgemein.laeuft : t.anmelden}
        </button>

        <p style={{ marginTop: 14, textAlign: 'center', fontSize: 14 }}>
          <Link to="/forgot">{t.passwortVergessen}</Link>
        </p>

        <p style={{ marginTop: 4, textAlign: 'center', fontSize: 14 }}>
          {t.keinKontoVor}
          <Link to="/register">{t.registrierung}</Link>
        </p>
      </form>
    </div>
  )
}
